module.exports = __webpack_public_path__ + "img/topadv_02.367a9354.jpg";